module.exports = " <div> <div id=footerCommon></div> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DFooter.vue
 ** module id = 605
 ** module chunks = 2
 **/